import { Popover as PopoverPrimitive } from '@base-ui/react/popover';

export type PopoverProps = PopoverPrimitive.Root.Props;

const Popover = ({ ...props }: PopoverProps) => {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
};

export default Popover;
